export default contestsResults => {
    const resultsSelect = contestsResults.querySelector('.select select');

    if (typeof (resultsSelect) != 'undefined' && resultsSelect != null) {
        resultsSelect.addEventListener('change', () => {
            if (resultsSelect.value !== '') {
                let userAgentString = navigator.userAgent;
                let chromeAgent = userAgentString.indexOf("Chrome") > -1;
                let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
                let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
                let safariAgent = userAgentString.indexOf("Safari") > -1;
                if ((chromeAgent) && (safariAgent)) safariAgent = false;
                if (safariAgent) {
                    window.location = resultsSelect.value;
                } else {
                    window.open(resultsSelect.value, '_blank');
                }
            }
        });
    }

};
